import Tokens from "@/components/ui/services/TokenService";

export default api => {
    return {
        namespaced: true,
        state: {
            schools: [],
        },
        getters: {
            all: state => state.schools,
            requiredSchool: (state, getters, rootState, rootGetters) => state.schools.length < 1 && rootGetters["account/isLoggedIn"],
            //checkRole: state => allowedRoles => state.user !== null && allowedRoles.some(role => state.user.roles.includes(role)),
        },
        mutations: {
            setSchools(state, schools) {
                state.schools = schools;
            },
        },
        actions: {
            init({commit}) {
                let schools = JSON.parse(localStorage.getItem(Tokens.STORAGE_KEY + '_schools') ?? null)
                if (!schools)
                    schools = []
                commit('setSchools', schools)
            },
            async _load({commit}) {
                const schools = await api.all()
                commit('setSchools', schools);
            },

            async all({dispatch, state}) {
                if (state.schools == null)
                    await dispatch('_load')
                return state.schools
            },

            async post({dispatch}, fields) {
                const school = await api.store(fields)
                await dispatch('_load')
                return school
            },

            async update({dispatch}, {id, fields}) {
                const school = await api.update(id, fields)
                await dispatch('_load')
                return school
            },

            async destroy({dispatch}, id) {
                await api.destroy(id)
                await dispatch('_load')
            }

        }
    }
}